function SectionCandidateSkills() {
    return (
        <>
            <h4 className="twm-s-title">Skills</h4>
            <div className="tw-sidebar-tags-wrap">
                <div className="tagcloud">
                    <a href="#">Finance</a>
                    <a href="#">Sales</a>
                    <a href="#">Part-time</a>
                    <a href="#">Administration</a>
                    <a href="#">Retail</a>
                    <a href="#">Engineering</a>
                    <a href="#">Developer</a>
                    <a href="#">Work from home</a>
                    <a href="#">IT Consulting</a>
                    <a href="#">Manufacturing</a>
                </div>
            </div>
        </>
    )
}

export default SectionCandidateSkills;